import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'natural-orderby';
import LinkList from './LinkList';
import WidgetErrorMessage from '../../WidgetErrorMessage';
import {
    displayMetricSourceError,
    getMetricSourceErrors,
    getMetricSourceForRequest,
    hasMetricSources,
} from '../../utils/wrapperUtils';
import DashboardContext from '../../../../shared/hooks/dashboardContext';

/* eslint-disable complexity */
function getMetricSource(metricRequests, metrics) {
    if (metricRequests.length !== 1) {
        return {
            errorKey: 'invalidMetricRequests',
        };
    }

    const metricSource = getMetricSourceForRequest(metrics, metricRequests[0]);
    if (!metricSource) {
        return {
            errorKey: 'metricSourceNotFound',
        };
    }

    if (!hasMetricSources([metricSource], true)) {
        return { errorKey: 'noItemsAvailable' };
    }

    const metricSourceErrors = getMetricSourceErrors(
        [metricSource],
        metricRequests
    );
    if (metricSourceErrors.length) {
        return { metricSourceErrors };
    }

    return { metricSource };
}
/* eslint-enable complexity */

function hydrateLinks(link, openLinksInNewTab, getNonApiUri) {
    return {
        displayText: link.displayText,
        icon: link.icon,
        target: openLinksInNewTab ? '_blank' : '',
        uri: link.isAbsoluteUri ? link.path : getNonApiUri(link.path),
        sortOrder: link.sortOrder,
    };
}

export default function LinkListWrapper(props) {
    const { uriConstants } = useContext(DashboardContext);
    const { metricSource, metricSourceErrors, errorKey } = getMetricSource(
        props.metricRequests,
        props.metrics
    );

    if (errorKey) {
        return (
            <WidgetErrorMessage>
                {props.dashboardLabels[errorKey]}
            </WidgetErrorMessage>
        );
    }

    if (metricSourceErrors) {
        return metricSourceErrors.map((error) => (
            <WidgetErrorMessage key={error.uniqueRequestString}>
                {displayMetricSourceError(error, props.dashboardLabels)}
            </WidgetErrorMessage>
        ));
    }

    const linksWithFullUri = metricSource.metricSeries.map((link) =>
        hydrateLinks(link, props.openLinksInNewTab, uriConstants.getNonApiUri)
    );

    return (
        <LinkList
            links={orderBy(linksWithFullUri, ['sortOrder', 'displayText'])}
        />
    );
}

LinkListWrapper.propTypes = {
    dashboardLabels: PropTypes.instanceOf(Object).isRequired,
    metricRequests: PropTypes.instanceOf(Array).isRequired,
    metrics: PropTypes.instanceOf(Array).isRequired,
    openLinksInNewTab: PropTypes.bool.isRequired,
};
